import {ModuleController} from "../../../../infrastructure/controllers/module-controller";
import {BaseManagedService} from "../../../../infrastructure/domain-services/base-managed-service";
import {GameCenterHeaderConfig} from "./game-center-header-module.config";
import {GameCenterHeaderModuleStore} from "./game-center-header-module.store";
import {GameCenterHeaderModuleHandlers} from "./handlers/game-center-header-module.handlers";

export class GameCenterHeaderModuleController extends ModuleController {
  static injectables = [...BaseManagedService.injectables,  GameCenterHeaderConfig, GameCenterHeaderModuleStore, GameCenterHeaderModuleHandlers];
}
